
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/community/groups/[groupId]/activity",
      function () {
        return require("private-next-pages/community/groups/[groupId]/activity.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/community/groups/[groupId]/activity"])
      });
    }
  